import styled, {css} from "styled-components";

interface IStickyNavigationMenuItemIconBoxProps {
    isActive: boolean;
}

export const StickyNavigationMenuItemIconDefaultBox = styled.div<IStickyNavigationMenuItemIconBoxProps>`
    width: 2.4rem;
    height: 2.4rem;
    transition: color 0.2s ease, background-color 0.2s ease, border-bottom 0.2s ease;
    ${(props) => props.isActive ? css`
        color: ${(props) => props.theme.colors.textActive};
    ` : null}
`;
